import React from 'react';
import Tippy from '@tippyjs/react';
import Constants from 'components/utils/constants';


class PopupCellRenderer extends React.Component {

  state = {
    visible: false,
    value: this.props.value,
    sid: '',
    name: '',
    colId: '',
    termObj: {}
  }

  componentDidMount() {
    let { column, data } = this.props;
    let { colId } = column;
    let { sid, name } = data;
    let termObj = this.props.getSubTerm(sid, parseInt(colId));
    this.setState({
      sid,
      name,
      colId,
      termObj
    })
  }

  show = () => this.setState({ visible: true })
  hide = () => this.setState({ visible: false })
  toCurr = (amnt) => Constants.toCurrencyES6(amnt, this.props.getAccountCurr())


  dropDownContent = () => {
    let { value, name, termObj } = this.state;
    let { date, status, amnt, bid } = termObj;
    let isPaid = value === 'paid';
    return (
      <div className="pop-up-menu-container">
        <div>
          <div>{`Name: ${name}`}</div>
          <div>{`Date: ${date}`}</div>
          {bid && <div>{`Chit Win: ${this.toCurr(bid)}`}</div>}
          <div>{`Term EMI: ${this.toCurr(amnt)}`}</div>
          {bid && <div>{`Payable: ${this.toCurr(bid - amnt)}`}</div>}
          <div>{`Status: ${status}`}</div>
        </div>
        <hr />
        <div
          onClick={() => this.onClickHandler()}
          className={`btn btn-${isPaid ? 'danger' : 'info'} btn-lg`}>
          {`Mark ${isPaid ? 'due' : 'paid'}`}
        </div>
      </div>
    );
  }

  onClickHandler = () => {
    this.hide();
    let { colId, sid, value } = this.state;
    // console.log('this.props', this.props)
    this.props.onStatusUpdate(colId, sid, value);
  };

  render() {
    let { visible, termObj } = this.state;
    let { isAuthorized } = this.props;
    let isBidder = termObj.bid ? '#' : '';
    return (
      <Tippy
        // ref={tippyRef}
        content={this.dropDownContent()}
        visible={visible}
        onClickOutside={() => this.hide()}
        allowHTML={true}
        arrow={false}
        appendTo={document.body}
        interactive={true}
        placement="right"
      >
        <button
          className={`pop-up-menu-button btn btn-${this.state.value === 'paid' ? (isBidder ? 'info' : 'success') : (isBidder ? 'danger' : 'warning')} btn-sm  btn-outline-primary py-0`}
          onClick={() => {
            if ( isAuthorized ) {
              if (visible) {
                this.hide();
              } else {
                this.show();
              }
            } else {
              this.props.snackbar(`Sorry, you are not authorized to perform this action.`, {
                variant: 'warning'
              })
            }
          }}
          >
          {this.state.value + `${isBidder}`}
        </button>
      </Tippy>
    );
  }
};

export default PopupCellRenderer;
